import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";


/* Get Notification Service*/
const getNotification = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.notification.getNotification}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Update Notification Service*/
const updateNotification = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.notification.updateNotification}`,
    method: "PUT",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Delete Notification Service*/
const deleteNotification = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.notification.deleteNotification}`,
    method: "DELETE",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Delete All Notification Service*/
const deleteAllNotification = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.notification.deleteAllNotification}`,
    method: "DELETE",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

export default {
  getNotification,
  updateNotification,
  deleteNotification,
  deleteAllNotification,
}